import { render, staticRenderFns } from "./KPIList.vue?vue&type=template&id=45452162"
import script from "./KPIList.vue?vue&type=script&lang=js"
export * from "./KPIList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports